import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { createProductHoldRequest } from "../../../thunks/buyer-thunks/BuyerThunks";

const initialState = {
  isHoldLoading: false,
  productHoldRequest: null,
  error: null,
};
export const productHoldRequests = createSlice({
  name: "productHoldRequests",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createProductHoldRequest.pending, (state) => {
        state.isHoldLoading = true;
        state.error = null;
      })
      .addCase(createProductHoldRequest.fulfilled, (state, action) => {
        state.isHoldLoading = false;
        state.productHoldRequest = action.payload;
      })
      .addCase(createProductHoldRequest.rejected, (state, action) => {
        state.isHoldLoading = false;
        state.error = action.payload;
      });
  },
});

export default productHoldRequests.reducer;
